import { i18n as _i18n } from "@lingui/core";
import { useLingui } from '@lingui/react';
import { CarleadCreationButton, CarleadCreationForm, CarleadMileageFormatted, defaultCarleadSplitFlow, Email, PricedCarsCounter, QuestionnaireBoxSelect, QuestionnaireSelect, renderFieldVerticalWrapper, SplitBodyTypes, SplitDoorCount, SplitFuelType, SplitGearType, SplitHorsePower, SplitMainTypeDetails, SplitMainTypesSub, useCreateCarleadChainedRequest, useCreateConsumerCarleadRequestChain, useFormQuestionnaireProps, useSplitFieldsFlowService, useSplitFieldsProps, useStep2CarleadForm } from '@wkda/carlead-creation-components';
import { useTrackLanding } from '@wkda/funnel-components';
import { Paper } from '@wkda/styleguide';
import { CarleadProgress, ReturningCustomerPopup, TermsAndConditions, TrustPilot } from '../../../../../components';
import React from 'react';
import { useMinimumMileageValidation } from '../../../../../hooks';
import { carleadQuestionnaireWithBuyCarQuestionPartialFlow } from '../../../../../constants';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const CarleadStep2CustomerPopupBuyCar = _ref => {
  let {
    wide = false,
    headlineDesktop = 'carleadCreation.form.step2.headline',
    headlineMobile = 'carleadCreation.form.step2.headline',
    className = '',
    showCounterHeadline = false,
    showTerms = false
  } = _ref;
  const flow = {
    ...defaultCarleadSplitFlow,
    ...carleadQuestionnaireWithBuyCarQuestionPartialFlow
  };
  const questionnaireProps = useFormQuestionnaireProps(flow);
  const splitFieldsProps = useSplitFieldsProps();
  const machine = useSplitFieldsFlowService(flow);
  const mileageProps = useMinimumMileageValidation();
  const request = useCreateCarleadChainedRequest([
  // make this the last one
  useCreateConsumerCarleadRequestChain()]);
  const consumerForm = useStep2CarleadForm([questionnaireProps, splitFieldsProps, mileageProps]);
  const {
    i18n
  } = useLingui();
  useTrackLanding();
  return /*#__PURE__*/_jsxs(Paper, {
    className: "carlead-creation-form__container step-2",
    children: [/*#__PURE__*/_jsx(ReturningCustomerPopup, {}), /*#__PURE__*/_jsx("div", {
      className: `box gap full-height ${className}`,
      children: /*#__PURE__*/_jsxs("div", {
        className: `container ${wide ? 'container-xl' : ''}`,
        children: [showCounterHeadline ? /*#__PURE__*/_jsx(PricedCarsCounter, {}) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("h1", {
            className: "carlead-creation-form__title hidden-md ",
            dangerouslySetInnerHTML: {
              __html: i18n._(headlineDesktop)
            }
          }), /*#__PURE__*/_jsx("h1", {
            className: "carlead-creation-form__title hidden-lg",
            dangerouslySetInnerHTML: {
              __html: i18n._(headlineMobile)
            }
          })]
        }), /*#__PURE__*/_jsxs(CarleadCreationForm, {
          carleadForm: consumerForm,
          options: {
            name: 'StepCompound'
          },
          machineService: machine,
          submitHandler: request,
          children: [/*#__PURE__*/_jsx(SplitBodyTypes, {}), /*#__PURE__*/_jsx(SplitFuelType, {
            isHiddenField: true
          }), /*#__PURE__*/_jsx(SplitMainTypeDetails, {
            isHiddenField: true
          }), /*#__PURE__*/_jsx(SplitHorsePower, {
            isHiddenField: true
          }), /*#__PURE__*/_jsx(SplitGearType, {
            isHiddenField: true
          }), /*#__PURE__*/_jsx(SplitDoorCount, {
            isHiddenField: true
          }), /*#__PURE__*/_jsx(SplitMainTypesSub, {
            isHiddenField: true
          }), /*#__PURE__*/_jsx(CarleadMileageFormatted, {
            lowerThreshold: 2500,
            upperThreshold: 35000,
            suspiciousMileageMessageDelay: 2000,
            isHiddenField: true,
            renderFieldWrapper: renderFieldVerticalWrapper
          }), /*#__PURE__*/_jsx(QuestionnaireSelect, {
            renderFieldWrapper: renderFieldVerticalWrapper,
            name: "SELLPOINT",
            label: _i18n._(
            /*i18n*/
            {
              id: 'carleadCreation.form.label.sellpoint'
            }),
            isHiddenField: true,
            answers: [{
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.sellpointNow'
              }),
              value: 'SELLPOINT_NOW'
            }, {
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.sellpoint4weeks'
              }),
              value: 'SELLPOINT_4_WEEKS'
            }, {
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.sellpoint3months'
              }),
              value: 'SELLPOINT_3_MONTHS'
            }, {
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.sellpointNotPlanned'
              }),
              value: 'SELLPOINT_NOT_PLANNED'
            }]
          }), /*#__PURE__*/_jsx(QuestionnaireSelect, {
            renderFieldWrapper: renderFieldVerticalWrapper,
            name: "SELL_TYPES",
            label: _i18n._(
            /*i18n*/
            {
              id: 'carleadCreation.form.label.sellTypes'
            }),
            isHiddenField: true,
            answers: [{
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.sellTypesPrivate'
              }),
              value: 'PRIVATE'
            }, {
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.sellTypesDealer'
              }),
              value: 'DEALER'
            }]
          }), /*#__PURE__*/_jsx(QuestionnaireBoxSelect, {
            renderFieldWrapper: renderFieldVerticalWrapper,
            name: "BUY_CAR",
            isHiddenField: true,
            label: _i18n._(
            /*i18n*/
            {
              id: 'carleadCreation.form.label.buyCar'
            }),
            answers: [{
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.buyCarYES'
              }),
              value: 'YES'
            }, {
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.buyCarNO'
              }),
              value: 'NO'
            }]
          }), /*#__PURE__*/_jsx(Email, {
            isHiddenField: true,
            renderFieldWrapper: renderFieldVerticalWrapper
          }), /*#__PURE__*/_jsx(CarleadProgress, {}), showTerms && /*#__PURE__*/_jsx(TermsAndConditions, {}), /*#__PURE__*/_jsx(CarleadCreationButton, {})]
        }), showTerms && /*#__PURE__*/_jsx("div", {
          className: "conditions-text__container"
        }), /*#__PURE__*/_jsxs("section", {
          className: "trust-box",
          children: [/*#__PURE__*/_jsx("div", {
            className: "d-none d-md-block",
            children: /*#__PURE__*/_jsx(TrustPilot, {
              type: "lead",
              screen: "desktop"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "d-block d-md-none",
            children: /*#__PURE__*/_jsx(TrustPilot, {
              type: "lead",
              screen: "mobile"
            })
          })]
        })]
      })
    })]
  });
};
export default CarleadStep2CustomerPopupBuyCar;